module.exports = __webpack_public_path__ + "static/media/Local Servers.42711a67.svg";